<template>
    <div class="section-box project-pay">
        <el-row class="row-bg">
            <el-col :span="12" style="text-align: left;line-height: 36px;">
                <el-badge :value="icon.a" style="margin-right: 25px;" :max="99">
                    <el-button size="mini" @click="chose(1)" :class="form.invoiceStatus ==1 ?'selected':''">待收票</el-button>
                </el-badge>
                <el-badge :value="icon.b" style="margin-right: 25px;" :max="99">
                    <el-button size="mini" @click="chose(2)" :class="form.invoiceStatus ==2 ?'selected':''">待支付</el-button>
                </el-badge>
                <el-badge :value="icon.c" style="margin-right: 25px;" :max="99">
                    <el-button size="mini" @click="chose(3)" :class="form.invoiceStatus ==3 ?'selected':''">已完成</el-button>
                </el-badge>
                <el-badge :value="icon.d" style="margin-right: 25px;" :max="99">
                    <el-button size="mini" @click="chose(4)" :class="form.invoiceStatus ==4 ?'selected':''">已拒绝</el-button>
                </el-badge>
            </el-col>
            <el-col :span="12" style="text-align: right;">
                <el-button size="medium" plain v-if="form.invoiceStatus ==1" @click="receivedAll()">确认收票</el-button>
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
                <el-button size="medium" type="primary" icon="el-icon-download" @click="downloadFile()">下载数据</el-button>
            </el-col>
        </el-row>

        <!-- 列表 -->
        <el-table
            ref="tableData"
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="666"
            border
            @selection-change="handleSelectionChange"
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column type="selection" width="55" v-if="form.invoiceStatus ==1"></el-table-column>
            <el-table-column label="账户">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.userName" placeholder="输入关键字搜索" @blur="GetCouponsList()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.userName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发票抬头" >
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.invoiceTitle" placeholder="输入关键字搜索" @blur="GetCouponsList()"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.invoiceTitle || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="开票选项" >
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.invoiceContentId" placeholder="请选择开票选项" style="width: 100%;" @change="GetCouponsList()">
                            <el-option value="" label="请选择"></el-option>
                            <el-option :value="item.key" :label="item.value" v-for="(item, index) in invoiceContentOptionArr" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.invoiceContent || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="税点">
                <el-table-column show-overflow-tooltip width="180">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.taxPointId" placeholder="请选择税点" style="width: 100%;" @change="GetCouponsList()">
                            <el-option :value="item.key" :label="item.value" v-for="(item, index) in taxPointOptionArr" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.taxPoint || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发票金额">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.invoiceMoneyBegin" style="width: 45%;" placeholder="搜索" type="number"/> ~
                        <el-input size="mini" v-model="form.invoiceMoneyEnd" style="width: 45%;" placeholder="搜索" @blur="GetCouponsList()" type="number"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.invoiceMoney || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发票日期" >
                <el-table-column show-overflow-tooltip width="250">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.EffectivityTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                            @change="GetCouponsList()"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.invoiceDt || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="申请时间" >
                <el-table-column show-overflow-tooltip width="250">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.EffectivityTime2"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                            @change="GetCouponsList()"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" @click="openInvoice(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <p style="margin-bottom: -42px;font-size: 14px;line-height: 32px;">已选中 {{num}} 条信息</p>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageNo"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <DetailsInvoice ref="detailsInvoice"/>
    </div>
</template>

<script>
import DetailsInvoice from './index/detailsInvoice'
// DOTO：静态展示数据 对接的时候可以删掉
import { PERIOD } from '@/config/const/common.js'
// End
import { 
  getStorageToken,
} from '@/utils/store'
import {
    paymentManageList,
    paymentManageCount,
    batchTicket,invoiceContentOption,taxPointOption,
} from "@/service/payApi";
  export default {
    components: {
        DetailsInvoice
    },
    data() {
        return {
            PERIOD,
            listLoading: false,
            form: {
                PageNo: 1,
                PageSize: 10,

                EffectivityTime: [],    //时间
                EffectivityTime2: [],    //时间
                invoiceContentId:'',
                invoiceMoneyBegin:'',
                invoiceMoneyEnd:'',
                invoiceStatus:1,
                invoiceTitle:'',
                taxPointId:'',
                userName:'',
            },
            num: 0,
            searchData:{},
            oraginForm:{},
            total: 0,                       //总条数
            tableData:[],
            icon:{
                a:0,
                b:0,
                c:0,
                d:0
            },
            selected_items:{},
            ids:[],
            invoiceContentOptionArr:[],
            taxPointOptionArr:[],
        }
    },
    activated(){
        this.handleSearch()
        this.getInvoiceContentOption()
        this.getTaxPointOption()
    },
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        getTaxPointOption(){
                taxPointOption().then((r)=>{
                    if(r.Result != 1){
                        return this.$message.error(r.Message)
                    }
                    this.taxPointOptionArr = r.Data
                })
            },
        getInvoiceContentOption(){
                invoiceContentOption().then((r)=>{
                    if(r.Result != 1){
                        return this.$message.error(r.Message)
                    }
                    this.invoiceContentOptionArr = r.Data
                })
            },
        downloadFile() {
            const _this = this
            let data = {
            }
            if (_this.form.EffectivityTime instanceof Array &&_this.form.EffectivityTime.length > 0) {
                    data.invoiceDtBegin = _this.form.EffectivityTime[0] + " 00:00:00";
                    data.invoiceDtEnd = _this.form.EffectivityTime[1] + " 23:59:59";
                } else {
                    if (data.invoiceDtBegin) delete data.invoiceDtBegin;
                    if (data.invoiceDtEnd) delete data.invoiceDtEnd;
                }
            if (_this.form.EffectivityTime2 instanceof Array &&_this.form.EffectivityTime2.length > 0) {
                    data.createTimeBegin = _this.form.EffectivityTime2[0] + " 00:00:00";
                    data.createTimeEnd = _this.form.EffectivityTime2[1] + " 23:59:59";
                } else {
                    if (data.createTimeBegin) delete data.createTimeBegin;
                    if (data.createTimeEnd) delete data.createTimeEnd;
                }    

            if(this.form.invoiceContentId) data.invoiceContentId = this.form.invoiceContentId
            if(this.form.invoiceMoneyBegin) data.invoiceMoneyBegin = this.form.invoiceMoneyBegin
            if(this.form.invoiceMoneyEnd) data.invoiceMoneyEnd = this.form.invoiceMoneyEnd
            if(this.form.invoiceStatus) data.invoiceStatus = this.form.invoiceStatus
            if(this.form.invoiceTitle) data.invoiceTitle = this.form.invoiceTitle
            if(this.form.taxPointId) data.taxPointId = this.form.taxPointId
            if(this.form.userName) data.userName = this.form.userName

            let url =
            process.env.NODE_ENV == "development" ?
            "/api2" :
            process.env.VUE_APP_API2;

            window.open(
            url + "/gz/admin/download/paymentManage/download" + "?" + this.parseJsonURL(data)
            );
        },
        parseJsonURL(json) {
            if (!json) return "";
            if (typeof json == "string") return json;
            return this.cleanArray(
            Object.keys(json).map(function (key) {
                if (json[key] === undefined) return "";
                return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
            })
            ).join("&");
        },
        cleanArray(actual) {
        var newArray = [];
        for (var i = 0; i < actual.length; i++) {
          if (actual[i]) {
            newArray.push(actual[i]);
          }
        }
        return newArray;
      },
        getCount(){
            const _this = this
            let data = {
                pageNum:this.form.PageNo,
                pageSize:this.form.PageSize,   
                rational:true,
            }
            // !data.Name && delete data.Name
            data.Token = getStorageToken();
            data.platform = 'zyd'
            if (_this.form.EffectivityTime instanceof Array &&_this.form.EffectivityTime.length > 0) {
                    data.invoiceDtBegin = _this.form.EffectivityTime[0] + " 00:00:00";
                    data.invoiceDtEnd = _this.form.EffectivityTime[1] + " 23:59:59";
                } else {
                    if (data.invoiceDtBegin) delete data.invoiceDtBegin;
                    if (data.invoiceDtEnd) delete data.invoiceDtEnd;
                }
            if (_this.form.EffectivityTime2 instanceof Array &&_this.form.EffectivityTime2.length > 0) {
                    data.createTimeBegin = _this.form.EffectivityTime2[0] + " 00:00:00";
                    data.createTimeEnd = _this.form.EffectivityTime2[1] + " 23:59:59";
                } else {
                    if (data.createTimeBegin) delete data.createTimeBegin;
                    if (data.createTimeEnd) delete data.createTimeEnd;
                }    

            if(this.form.invoiceContentId) data.invoiceContentId = this.form.invoiceContentId
            if(this.form.invoiceMoneyBegin) data.invoiceMoneyBegin = this.form.invoiceMoneyBegin
            if(this.form.invoiceMoneyEnd) data.invoiceMoneyEnd = this.form.invoiceMoneyEnd
            if(this.form.invoiceStatus) data.invoiceStatus = this.form.invoiceStatus
            if(this.form.invoiceTitle) data.invoiceTitle = this.form.invoiceTitle
            if(this.form.taxPointId) data.taxPointId = this.form.taxPointId
            if(this.form.userName) data.userName = this.form.userName

            paymentManageCount(data).then((r)=>{
                if(r.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
                }
                let temp = r.Data
                for(var i=0;i<temp.length;i++){
                    if(temp[i].invoiceStatus == 1){
                        this.icon.a = temp[i].count
                    }
                    if(temp[i].invoiceStatus == 2){
                        this.icon.b = temp[i].count
                    }
                    if(temp[i].invoiceStatus == 3){
                        this.icon.c = temp[i].count
                    }
                    if(temp[i].invoiceStatus == 4){
                        this.icon.d = temp[i].count
                    }
                }
            })
            
        },
        chose(type){
            this.form.invoiceStatus = type;this.form.PageNo=1;this.form.PageSize=10
            this.GetCouponsList()
        },
        //渲染列表
        handleSearch() {
            this.searchData = Object.assign({}, this.form)
            this.GetCouponsList()
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.PageNo = val
            this.searchData.PageNo = val
            this.GetCouponsList()
        },
        //翻页
        handleSizeChange(val) {
        if (this.listLoading) return
            this.form.PageNo = 1
            this.form.PageSize = val
            this.searchData.PageNo = 1
            this.searchData.PageSize = val
            this.GetCouponsList()
        },
        // TODO：修改接口名 form参数 table展示数据 -> 发单方身份、服务来源select
        async GetCouponsList(){
            const _this = this
            this.getCount()
            this.listLoading = true
            let data = {
                pageNum:this.form.PageNo,
                pageSize:this.form.PageSize,   
                rational:true,
            }
            // !data.Name && delete data.Name
            data.Token = getStorageToken();
            data.platform = 'zyd'
            if (_this.form.EffectivityTime instanceof Array &&_this.form.EffectivityTime.length > 0) {
                    data.invoiceDtBegin = _this.form.EffectivityTime[0] + " 00:00:00";
                    data.invoiceDtEnd = _this.form.EffectivityTime[1] + " 23:59:59";
                } else {
                    if (data.invoiceDtBegin) delete data.invoiceDtBegin;
                    if (data.invoiceDtEnd) delete data.invoiceDtEnd;
                }
            if (_this.form.EffectivityTime2 instanceof Array &&_this.form.EffectivityTime2.length > 0) {
                    data.createTimeBegin = _this.form.EffectivityTime2[0] + " 00:00:00";
                    data.createTimeEnd = _this.form.EffectivityTime2[1] + " 23:59:59";
                } else {
                    if (data.createTimeBegin) delete data.createTimeBegin;
                    if (data.createTimeEnd) delete data.createTimeEnd;
                }    

            if(this.form.invoiceContentId) data.invoiceContentId = this.form.invoiceContentId
            if(this.form.invoiceMoneyBegin) data.invoiceMoneyBegin = this.form.invoiceMoneyBegin
            if(this.form.invoiceMoneyEnd) data.invoiceMoneyEnd = this.form.invoiceMoneyEnd
            if(this.form.invoiceStatus) data.invoiceStatus = this.form.invoiceStatus
            if(this.form.invoiceTitle) data.invoiceTitle = this.form.invoiceTitle
            if(this.form.taxPointId) data.taxPointId = this.form.taxPointId
            if(this.form.userName) data.userName = this.form.userName

            let res = await paymentManageList(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }
            const old = JSON.parse(JSON.stringify(this.selected_items));
            this.selected_items = {};

            this.tableData = res.Data.datas
            this.total = res.Data.total
            this.num = Object.keys(old).length;

            this.$forceUpdate();

            if (Object.keys(old).length)
            this.$nextTick(() => {
                for (var idx1 in _this.tableData) {
                const item1 = _this.tableData[idx1];
                if (old[item1.id]) {
                    _this.$refs.tableData.toggleRowSelection(item1);
                }
                }

                for (var key1 in old) {
                const item2 = old[key1];
                _this.selected_items[key1] = item2;
                }

                _this.num = Object.keys(_this.selected_items).length;
+               _this.$forceUpdate();
          });

        },
        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()

            this.selected_items = {};
            this.$forceUpdate();
        },
        // table选中
        handleSelectionChange(val) {
            for (var idx in this.tableData)                                                      
            {                                                                                    
                const item = this.tableData[idx];                                                
                if (this.selected_items[item.id]) delete this.selected_items[item.id]; 
            }                                                                                    
            for (var idx in val)
            {
                const item2 = val[idx];
                this.selected_items[item2.id] = item2;
            }

            // debugger
            // console.table(val)
            this.num = Object.keys(this.selected_items).length;
        },
        // 点击详情
        openInvoice(row){ 
            this.$refs.detailsInvoice.open(row,this.form.invoiceStatus)
        },
        // 点击批量收票
        receivedAll(){
            const _this = this;
            this.ids = [];
            var temp = '';
            for (var key in this.selected_items)
            {
                const item = this.selected_items[key];
                this.ids.push(item.id);
                temp+=item.id+','
            }

            temp = temp.substr(0, temp.length - 1)

            this.$confirm("是否确认收票", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        var data = {
                            ids: temp
                        };
                        this.listLoading = true
                        batchTicket(data).then((r) => {
                            this.listLoading = false
                            if (r.Result != 1) {
                                return this.$message.error(r.Message);
                            }
                            this.$message.success("收票成功");
                            this.handleReset()
                            this.GetCouponsList()
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消收票",
                        });
                    });
        },
    }
  }
</script>

<style lang="scss">
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
    .project-pay {
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }
</style>